import { filterRulesMapped } from '@/tools/filterRules'
import { getDateTimeRange, getChildrenFromList, arrayToTextFormatted, selectorDateTimeValidation, reportTimeRangeDetail } from '@/tools/functions'
import SelectorComponent from '@/components/commons/selector/SelectorComponent.vue'
import { scoringService } from '@/services/scoring.service'
import { geoReferenceApi, cancelGeoData } from '@/api/geoReference.api'
import { thingService } from '@/services/thing.service'
import { personService } from '@/services/person.service'
import { configurationService } from '@/services/configuration.service'
import { enterpriseService } from '@/services/enterprise.service'
import { TimeRanges, CustomTimeRangeTypes } from '@colven/common-domain-lib/lib'
import { SelectorModel } from '@/constants/constants'
import { clone } from 'ramda'
import i18n from '@/i18n'
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import BreadcrumbComponent from '@/components/commons/report-breadcrumb/BreadcrumbComponent.vue'

// CONSTANTE DE CANTIDAD MÁXIMA DE GEO REQUESTS ACTIVAS
const MAX_GEO_REQUEST = 10
// RADIO PARA GEO REQUESTS (en metros)
const GEO_REQUEST_RADIUS = 20

const COMPONENT_ID = 'DISCARDED_INFRACTIONS_REPORT'

export default {
    name: 'discardedInfractionsReport',
    components: {
        SelectorComponent,
        BreadcrumbComponent
    },
    data: () => ({
        // datos para la tabla
        tableHeaders: [],
        tableFilterRules: {},
        tableData: [],
        tableDataKey: '_id',
        tableComponentButtons: [],
        geoDataIndex: -1,
        requestCountGeoData: 0,
        loadingTable: true,
        rowActions: [],
        disableRefreshTable: true,
        tableSettingBtnDisabled: false,
        tableConfig: {},

        //SELECTOR
        // mostrar / ocultar el selector (navigation drawer)
        showSelector: false,
        // modelo del selector
        selectorModel: clone(SelectorModel),

        // backup de datos del selector
        selectedDateAndTimeRange: null,
        selectedDateAndTimeRangeCustomType: null,
        sinceDate: null,
        sinceTime: null,
        toDate: null,
        toTime: null,
        timestampFrom: null,
        timestampTo: null,
        enterprises: [],
        things: [],
        drivers: [],
        autoReport: false,
        autoReportMinutes: null,
        // interval instance
        intervalId: null,
        // se activa cuando las ubicaciones fueron resueltas
        ubicationResolved: false,
        // breadcrumb
        selectedTab: 'tab-table',
        tabs: [
            {
                id: 'tab-table',
                name: i18n.t('scoring.discardedInfractionsReport.name')
            }
        ],
    }),
    computed: {
        ...mapGetters('reportBreadcrumb', [
            'getDetails'
        ])
    },
    created () {
        // botón para resolver direcciones
        this.tableComponentButtons.push({
            id: 'get-geo-data',
            tooltip: i18n.t('loadLocations'),
            icon: 'explore',
            action: this.fireGeoDataRequests.bind(this),
            selectedData: false
        })
    },
    async mounted () {
        // Inicializo los datos del selector
        await this.initializeSelector()
    
        /*
        // configuración
        const initialLoad = await this.getConfiguration()
    
        // ejecuto la validación del selector, si es correcta, se cargan los datos, sino abro el selector
        if (initialLoad) {
            this.getReport({
                dateAndTimeRange: this.selectorModel.selectedDateAndTimeRange,
                dateAndTimeRangeCustomType: this.selectorModel.selectedDateAndTimeRangeCustomType,
                filters: this.selectorModel.filters,
                selects: this.selectorModel.selects,
                sinceDate: this.selectorModel.sinceDate,
                sinceTime: this.selectorModel.sinceTime,
                toDate: this.selectorModel.toDate,
                toTime: this.selectorModel.toTime,
            })
        } else {
            this.showSelector = true
            this.loadingTable = false
        }
        */

        // NO CARGO EL REPORTE, ABRO EL SELECTOR CON LA CONFIGURACION GUARDADA
        await this.getConfiguration()
        this.showSelector = true
        this.loadingTable = false
    },
    beforeDestroy() {
        // Cancelar las request pendientes
        if (this.requestCountGeoData > 0) {
            cancelGeoData('cancel geo-data requests')
        }
        clearTimeout(this.$_debounceTimeoutId)
        this.$_debounceTimeoutId = null

        // interval autoreport
        clearTimeout(this.intervalId)
        this.intervalId = null

        // reset breadcrumb
        this.reset()
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('reportBreadcrumb', [
            'setDetails',
            'reset'
        ]),
        fireGeoDataRequests () {
            const header = this.tableHeaders.find(h => h.value === 'location')
            if (header) {
              header.spinner = true
              header.cellConfig = { spinnerColor: '#03A9F4' }
              header.selected = true
            }
            this.getGeoData()
            this.ubicationResolved = true
        },
        /**
         * Obtener la GeoData de las filas del reporte
         */
        getGeoData () {
            this.geoDataIndex++
            if (this.geoDataIndex < this.tableData.length) {
                if (!this.tableData[this.geoDataIndex].location) {
                    this.geoRequest(this.tableData[this.geoDataIndex], this.geoDataIndex)
                } else {
                    this.getGeoData()
                }
            }
        },
        geoRequest (data, index) {
            this.requestCountGeoData++
            if (this.requestCountGeoData < MAX_GEO_REQUEST) {
                this.getGeoData()
            }
            geoReferenceApi.getGeoData(data.lat, data.long, GEO_REQUEST_RADIUS).then(response => {
                this.requestCountGeoData--
                if (this.requestCountGeoData < MAX_GEO_REQUEST) {
                    this.getGeoData()
                }
                const updatedItem = this.tableData[index]
                updatedItem.location = response.data.geoLocationData.title + ' - ' + response.data.geoLocationData.subtitle
                this.tableData.splice(index, 1, updatedItem)
            }).catch(() => {
                this.requestCountGeoData--
                if (this.requestCountGeoData < MAX_GEO_REQUEST) {
                    this.getGeoData()
                }
            })
        },
        /**
         * Para obtener la configuración de filtros
         * Esta función se ejecuta en mounted
         */
        async getConfiguration () {
            let initialLoad = true
            const config = await configurationService.get(COMPONENT_ID)

            if (config && config.data) {
                // config del filtro de empresa
                if (this.selectorModel.filters[0].data.length > 0 && config.data.enterprises && config.data.enterprises.length > 0) {
                    config.data.enterprises.forEach(enterprise => {
                        if (this.selectorModel.filters[0].data.find(t => t.id === enterprise.id) && !this.selectorModel.filters[0].selectedData.find(t => t.id === enterprise.id)) {
                            this.selectorModel.filters[0].selectedData.push(enterprise)
                        }
                    })
                    await this.selectEnterpriseCallback()
                } else {
                    initialLoad = false
                }

                // config del filtro de vehículos
                if (this.selectorModel.filters[1].data.length > 0 && config.data.things && config.data.things.length > 0) {
                    config.data.things.forEach(thing => {
                        if (this.selectorModel.filters[1].data.find(t => t.id === thing.id) && !this.selectorModel.filters[1].selectedData.find(t => t.id === thing.id)) {
                            this.selectorModel.filters[1].selectedData.push(thing)
                        }
                    })
                } else {
                    initialLoad = false
                }

                // config del filtro de vehículos
                if (this.selectorModel.filters[2].data.length > 0 && config.data.drivers && config.data.drivers.length > 0) {
                    config.data.drivers.forEach(driver => {
                        if (this.selectorModel.filters[2].data.find(d => d.id === driver.id) && !this.selectorModel.filters[2].selectedData.find(d => d.id === driver.id)) {
                            this.selectorModel.filters[2].selectedData.push(driver)
                        }
                    })
                } else {
                    initialLoad = false
                }

                // rango de tiempo
                if (config.data.selectedDateAndTimeRange) {
                    this.selectorModel.selectedDateAndTimeRange = config.data.selectedDateAndTimeRange

                    // custom
                    if (config.data.selectedDateAndTimeRange === TimeRanges.CUSTOM) {
                        if (config.data.selectedDateAndTimeRangeCustomType &&
                            config.data.selectedDateAndTimeRangeCustomType === CustomTimeRangeTypes.DATE) {
                            this.selectorModel.selectedDateAndTimeRangeCustomType = config.data.selectedDateAndTimeRangeCustomType
                            if (config.data.sinceDate && config.data.toDate) {
                                this.selectorModel.sinceDate = config.data.sinceDate
                                this.selectorModel.toDate = config.data.toDate
                            } else {
                                initialLoad = false
                            }
                        } else if (config.data.selectedDateAndTimeRangeCustomType &&
                            config.data.selectedDateAndTimeRangeCustomType === CustomTimeRangeTypes.DATE_AND_TIME) {
                            this.selectorModel.selectedDateAndTimeRangeCustomType = config.data.selectedDateAndTimeRangeCustomType
                            if (config.data.sinceDate && config.data.toDate && config.data.sinceTime && config.data.toTime) {
                                this.selectorModel.sinceDate = config.data.sinceDate
                                this.selectorModel.sinceTime = config.data.sinceTime
                                this.selectorModel.toDate = config.data.toDate
                                this.selectorModel.toTime = config.data.toTime
                            } else {
                                initialLoad = false
                            }
                        } else {
                            initialLoad = false
                        }
                    }
                }

                // autoreporte
                this.selectorModel.autoReport = config.data.autoReport
                this.selectorModel.autoReportMinutes = config.data.autoReportMinutes

                // config de la tabla
                if (config.data.tableConfig) {
                    this.tableConfig = config.data.tableConfig
                } else {
                    this.tableConfig = {}
                }
            } else {
                if (this.selectorModel.filters[0].data.length > 0 && this.selectorModel.filters[1].data.length > 0) {
                    this.selectorModel.filters[0].selectedData.cleanAndUpdate(this.selectorModel.filters[0].data)
                    this.selectorModel.filters[1].selectedData.cleanAndUpdate(this.selectorModel.filters[1].data)
                } else {
                    initialLoad = false
                }
            }

            return initialLoad
        },
        /**
         * Obtener los datos del reporte luego de procesar los datos de los filtros
         * @param {*} eventData 
         */
        getReport (eventData) {
            this.showSelector = false
            this.loadingTable = true
            this.disableRefreshTable = true

            // conversión del rango de tiempo elegido
            const conversion = getDateTimeRange(eventData.dateAndTimeRange, eventData.dateAndTimeRangeCustomType,
                eventData.sinceDate, eventData.sinceTime, eventData.toDate, eventData.toTime)
            this.selectedDateAndTimeRange = eventData.dateAndTimeRange
            this.selectedDateAndTimeRangeCustomType = eventData.dateAndTimeRangeCustomType
            this.sinceDate = eventData.sinceDate
            this.sinceTime = eventData.sinceTime
            this.toDate = eventData.toDate
            this.toTime = eventData.toTime
            this.timestampFrom = conversion.tFrom
            this.timestampTo = conversion.tTo

            // empresas seleccionadas
            this.enterprises = []
            const enterprisesSelected = eventData.filters[0].selectedData
            getChildrenFromList(enterprisesSelected, this.enterprises)

            // cosas seleccionadas
            this.things = []
            const thingsSelected = eventData.filters[1].selectedData
            getChildrenFromList(thingsSelected, this.things)

            // conductores seleccionados
            this.drivers = []
            const driversSelected = eventData.filters[2].selectedData
            getChildrenFromList(driversSelected, this.drivers)

            // otros valores del selector
            this.autoReport = eventData.autoReport
            this.autoReportMinutes = eventData.autoReportMinutes

            // guardo la configuración
            configurationService.save(COMPONENT_ID, {
                enterprises: eventData.filters[0].selectedData,
                things: eventData.filters[1].selectedData,
                drivers: eventData.filters[2].selectedData,
                selectedDateAndTimeRange: eventData.dateAndTimeRange,
                selectedDateAndTimeRangeCustomType: eventData.dateAndTimeRange === TimeRanges.CUSTOM ? eventData.dateAndTimeRangeCustomType : null,
                sinceDate: eventData.dateAndTimeRange === TimeRanges.CUSTOM ? eventData.sinceDate : null,
                sinceTime: eventData.dateAndTimeRange === TimeRanges.CUSTOM ? eventData.sinceTime : null,
                toDate: eventData.dateAndTimeRange === TimeRanges.CUSTOM ? eventData.toDate : null,
                toTime: eventData.dateAndTimeRange === TimeRanges.CUSTOM ? eventData.toTime : null,
                autoReport: eventData.autoReport,
                autoReportMinutes: eventData.autoReportMinutes,
                tableConfig: this.tableConfig
            })

            // obtengo los datos
            scoringService.getDiscardedInfractionsReport(
                this.drivers.map(driver => driver.driverCode),
                this.things.map(thing => thing.id),
                this.timestampFrom,
                this.timestampTo)
                .then(response => {
                    this.tableData.cleanAndUpdate(response.data)
                    this.tableHeaders.cleanAndUpdate(response.headers)
                    this.setTableFilterRules()
                    this.loadingTable = false
                    this.disableRefreshTable = false

                    // Cancelo las request de geo data que pudieran quedar activas y vuelvo a calcularlas en base a la nueva tabla
                    if (this.requestCountGeoData > 0) {
                        cancelGeoData('cancel geo-data requests')
                    }
                    this.geoDataIndex = -1
                    this.requestCountGeoData = 0
                    clearTimeout(this.$_debounceTimeoutId)
                    this.$_debounceTimeoutId = null

                    // detalles del reporte
                    this.setReportDetails()

                    // autoreporte
                    if (this.autoReport) {
                        const that = this
                        // interval del auto-reporte
                        clearInterval(that.intervalId)
                        that.intervalId = setInterval(
                            function () {
                                that.refreshTable()
                            },
                            that.autoReportMinutes * 60 * 1000)
                    }
                })
                .catch(() => {
                    this.loadingTable = false
                    this.disableRefreshTable = false
                })
        },
        /**
         * Inicializa los datos del selector
         */
        async initializeSelector () {
            // autoreporte
            this.selectorModel.showAutoReport = true

            // selector de empresa
            this.selectorModel.filters.push({
                id: 'enterprise-filter',
                name: this.$t('enterprise.name'),
                show: false,
                disabled: false,
                showDialog: false,
                singleSelect: true,
                data: [],
                selectedData: [],
                selectAction: this.selectEnterpriseCallback.bind(this)
            })
            // selector de vehículos
            this.selectorModel.filters.push({
                id: 'things',
                name: this.$t('equipment.name'),
                show: false,
                disabled: true,
                showDialog: false,
                singleSelect: false,
                data: [],
                selectedData: [],
                selectAction: undefined
            })
            // selector de conductores
            this.selectorModel.filters.push({
                id: 'driver-filter',
                name: this.$t('scoring.discardedInfractionsReport.driver'),
                show: false,
                disabled: true,
                showDialog: false,
                singleSelect: false,
                data: [],
                selectedData: [],
                selectAction: undefined
            })

            // solo se carga el selector de empresa
            const enteprises = await enterpriseService.getAllForFilter()
            this.selectorModel.filters[0].data.cleanAndUpdate(enteprises)
        },
        /**
         * Callback que se ejcuta cuando se selecciona una empresa
         */
        async selectEnterpriseCallback () {
            this.selectorModel.filters[1].selectedData = []
            this.selectorModel.filters[1].disabled = false
            this.selectorModel.filters[2].selectedData = []
            this.selectorModel.filters[2].disabled = false
            if (this.selectorModel.filters[0].selectedData.length > 0) {
                // datos para los selectores de vehículos y conductores 
                const enterpriseIds = this.selectorModel.filters[0].selectedData.map(enterprise => enterprise.id)
                const things = await thingService.getVehicleSelector(enterpriseIds)
                this.selectorModel.filters[1].data.cleanAndUpdate(things)
                const drivers = await personService.getDriverSelector(enterpriseIds)
                this.selectorModel.filters[2].data.cleanAndUpdate(drivers)
            }
        },
        /**
         * Acción de actualizar datos de la tabla
         */
        refreshTable () {
            this.loadingTable = true
            this.disableRefreshTable = true

            // actualizo los timestamp del rango de tiempo
            const conversion = getDateTimeRange(this.selectedDateAndTimeRange, this.selectedDateAndTimeRangeCustomType,
                this.sinceDate, this.sinceTime, this.toDate, this.toTime)
            this.timestampFrom = conversion.tFrom
            this.timestampTo = conversion.tTo

            // obtengo los datos
            scoringService.getDiscardedInfractionsReport(
                this.drivers.map(driver => driver.driverCode),
                this.things.map(thing => thing.id),
                this.timestampFrom,
                this.timestampTo)
                .then(response => {
                    const lastTableHeaders = clone(this.tableHeaders)
                    this.tableData.cleanAndUpdate(response.data)
                    const that = this
                    Vue.nextTick(function () {
                        that.tableHeaders.cleanAndUpdate(lastTableHeaders)
                    })
                    this.loadingTable = false
                    this.disableRefreshTable = false

                    // Cancelo las request de geo data que pudieran quedar activas y vuelvo a calcularlas en base a la nueva tabla
                    this.resetGeoData()
                    // si ya se han resuelto las ubicaciones, vuelvo a ejecutar el proceso
                    if (this.ubicationResolved) {
                        this.fireGeoDataRequests()
                    }
                })
                .catch(() => {
                    this.loadingTable = false
                    this.disableRefreshTable = false
                })
        },
        resetGeoData () {
            if (this.requestCountGeoData > 0) {
              cancelGeoData('cancel geo-data requests')
            }
            this.geoDataIndex = -1
            this.requestCountGeoData = 0
        },
        /**
         * Manejador de acciones de los botones de las filas
         * @param {*} button 
         * @param {*} data 
         */
        // eslint-disable-next-line no-unused-vars
        rowButtonClicked (button, data) {
            switch (button.id) {
                default:
                    console.warn('Button action not implemented')
                    break
            }
        },
        /**
         * Acción guardar configuración del botón de la tabla
         * @param {*} tableConfig
         */
        saveConfig (tableConfig) {
            // guardo la configuración
            configurationService.save(COMPONENT_ID, {
                enterprises: this.enterprises,
                things: this.things,
                drivers: this.drivers,
                selectedDateAndTimeRange: this.selectedDateAndTimeRange,
                selectedDateAndTimeRangeCustomType: this.selectedDateAndTimeRange === TimeRanges.CUSTOM ? this.selectedDateAndTimeRangeCustomType : null,
                sinceDate: this.selectedDateAndTimeRange === TimeRanges.CUSTOM ? this.sinceDate : null,
                sinceTime: this.selectedDateAndTimeRange === TimeRanges.CUSTOM ? this.sinceTime : null,
                toDate: this.selectedDateAndTimeRange === TimeRanges.CUSTOM ? this.toDate : null,
                toTime: this.selectedDateAndTimeRange === TimeRanges.CUSTOM ? this.toTime : null,
                autoReport: this.autoReport,
                autoReportMinutes: this.autoReportMinutes,
                tableConfig
            }, true)
        },
        /**
         * Para mostrar/ocultar el selector
         */
        selector () {
            this.showSelector = !this.showSelector
        },
        /**
         * Para setear las reglas de filtrado
         */
        setTableFilterRules () {
            this.tableFilterRules = {}
            this.tableHeaders.forEach(header => {
                this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]
            })
        },
        /**
         * Para setear las funciones de ordenamiento
         */
        setSortFunctions () {
            /*
                Para ordenar las columnas fecha y hora
                TO DO: analizar la posibilidad de incluir este tipo de sorting en el componente genérico
            */
        },
        /**
         * Para validar el selector de filtros y habilitar/deshabilitar el botón para guardar
         */
        validateSelector () {
            const that = this
            Vue.nextTick(function () {
                const enterprisesSelected = that.selectorModel.filters[0].selectedData
                const thingsSelected = that.selectorModel.filters[1].selectedData
                const driversSelected = that.selectorModel.filters[2].selectedData
                const customTimeValidation = selectorDateTimeValidation(that.selectorModel.selectedDateAndTimeRange,
                    that.selectorModel.selectedDateAndTimeRangeCustomType, that.selectorModel.customDateTimeValidForm,
                    that.selectorModel.sinceDate, that.selectorModel.sinceTime, that.selectorModel.toDate, that.selectorModel.toTime)
                that.selectorModel.disableSaveButton = enterprisesSelected.length === 0 ||
                    thingsSelected.length === 0 || driversSelected.length === 0 || customTimeValidation
            })
        },
        /**
         * Para cambiar de tab
         * @param {*} id
         */
        tabSelected (id) {
            this.selectedTab = id
        },
        /**
         * Detalles del reporte
         */
        setReportDetails () {
            // rango de tiempo formateado
            const timeRangeStr = reportTimeRangeDetail(this.selectedDateAndTimeRange, this.timestampFrom, this.timestampTo)

            // nombres de equipos formateados
            const thingNames = this.things.map(thing => thing.name)
            const thingsTextFormatted = arrayToTextFormatted(thingNames)

            // nombres de conductores formateados
            const driverNames = this.drivers.map(driver => driver.name)
            const driversTextFormatted = arrayToTextFormatted(driverNames)

            // nombres de empresas formateados
            const enterpriseNames = this.enterprises.map(enterprise => enterprise.name)
            const enterprisesTextFormatted = arrayToTextFormatted(enterpriseNames)

            let details = `<h3>${this.$t('scoring.discardedInfractionsReport.name')}</h3>`
            details += `<h5>${this.$t('enterprise.name')}: ${enterprisesTextFormatted}</h5>`
            details += `<h5>${this.$t('equipment.name')}: ${thingsTextFormatted}</h5>`
            details += `<h5>${this.$t('scoring.discardedInfractionsReport.driver')}: ${driversTextFormatted}</h5>`
            details += `<h5>${timeRangeStr.timeRange}</h5>`
            if (timeRangeStr.from) {
                details += `<h5>${timeRangeStr.from}</h5>`
            }
            if (timeRangeStr.to) {
                details += `<h5>${timeRangeStr.to}</h5>`
            }

            this.setDetails(details)
        }
    },
    watch: {
        'selectorModel.filters': {
            handler: function () {
                this.validateSelector()
            },
            deep: true
        },
        'selectorModel.selectedDateAndTimeRange': {
            handler: function () {
                this.validateSelector()
            },
            deep: true
        },
        'selectorModel.selectedDateAndTimeRangeCustomType': {
            handler: function () {
                this.validateSelector()
            },
            deep: true
        },
        'selectorModel.sinceDate': {
            handler: function () {
                this.validateSelector()
            },
            deep: true
        },
        'selectorModel.sinceTime': {
            handler: function () {
                this.validateSelector()
            },
            deep: true
        },
        'selectorModel.toDate': {
            handler: function () {
                this.validateSelector()
            },
            deep: true
        },
        'selectorModel.toTime': {
            handler: function () {
                this.validateSelector()
            },
            deep: true
        },
        /**
         * [EVALUAR SI CORRESPONDE LA APLICACIÓN DE ESTA VERIFICACIÓN]
         * Si hay MAX_GEO_REQUEST requests activas, activo un temporizador. Si se cumple el tiempo, entonces cancelo
         * las requests activas y continuo buscando.
         * Este "reseteo" se emplea para evitar que el proceso se quede congelado en requests de las cuales no se obtiene
         * una respuesta.
         * Cuando hay menos de MAX_GEO_REQUEST, el proceso continua sin la activación de temporizadores.
         */
        requestCountGeoData () {
            if (this.requestCountGeoData === MAX_GEO_REQUEST) {
                const that = this
                if (that.geoDataIndex < that.tableData.length) {
                    clearTimeout(that.$_debounceTimeoutId)
                    that.$_debounceTimeoutId = null
                    that.$_debounceTimeoutId = setTimeout(() => {
                        cancelGeoData('cancel geo-data requests')
                        that.requestCountGeoData = 0
                        that.getGeoData()
                    }, 60000)
                } else {
                    if (that.tableData.filter(a => !a.location).length > 10) {
                        clearTimeout(that.$_debounceTimeoutId)
                        that.$_debounceTimeoutId = null
                        that.$_debounceTimeoutId = setTimeout(() => {
                            cancelGeoData('cancel geo-data requests')
                            that.geoDataIndex = -1
                            that.requestCountGeoData = 0
                            that.getGeoData()
                        }, 60000)
                    }
                }
            } else {
                clearTimeout(this.$_debounceTimeoutId)
                this.$_debounceTimeoutId = null
            }
        },
    },
}
